<template>
  <div class="news-block py-4 md:py-8" :class="[model.background]">
    <div class="container mx-auto max-w-screen-xl px-4">
      <VcTypography :tag="model.heading" v-if="model.title" class="mb-5">
        {{ model.title }}
      </VcTypography>

      <div class="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-10 lg:grid-cols-3 lg:gap-12">
        <div v-for="(item, index) in model.newsItems" :key="index">
          <a
            :href="item.link"
            class="news-block__link h-[250px]"
            :class="model.textColor ? model.textColor : 'text-white'"
            :aria-label="item.title"
          >
            <VcImage :src="item.image" :alt="item.alttext" />
            <div class="news-block__title text-lg lg:text-2xl">
              {{ item.title }}
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  model: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss">
.news-block {
  &__link {
    position: relative;
    overflow: hidden;
    display: block;
    border-radius: 16px;
    font-weight: bold;

    &:after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(168, 168, 168, 0) 41.67%, #161616 100%);
    }

    img {
      width: 100%;
      height: auto;
      transition: all 0.3s ease-in-out;
      filter: blur(0);
    }

    &:hover img {
      transform: scale(1.1);
    }
  }

  &__title {
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
    z-index: 2;
  }
}
</style>
